import { groupBy } from "lodash";
import useBookingCategories from "PFCore/hooks/use_booking_categories";

import { TooltipDetails } from "../../../../types/row";
import { calculateHoursBooked } from "../../../helpers";

type CategoryDuration = {
  id: number;
  duration: number;
};

type UseOtherBookingsTooltipDetails = {
  categoriesDuration: CategoryDuration[];
};

export const useOtherBookingsTooltipDetails = ({
  categoriesDuration
}: UseOtherBookingsTooltipDetails): TooltipDetails[] => {
  const { bookingCategories } = useBookingCategories();
  const durationGroupedByCategory = groupBy(categoriesDuration, ({ id }) => id);
  const tooltipDetails = Object.entries(durationGroupedByCategory)
    .map(([categoryId, categoryDurations]) => {
      const bookingCategory = bookingCategories.find(({ id }) => id === Number(categoryId));
      if (bookingCategory) {
        return {
          categoryName: bookingCategory.display_as,
          bookedHours: calculateHoursBooked(categoryDurations)
        };
      }
      return null;
    })
    .filter((tooltipDetailsItem) => tooltipDetailsItem) as TooltipDetails[];

  return tooltipDetails.filter(({ bookedHours }) => bookedHours);
};
